import React from 'react';
import { Container, CustomIFrame } from './styles';
import Page from '../../components/page';
import { RiShieldLine } from 'react-icons/ri';

const PageCybersecurity = () => {
  return (
    <Page title='Cybersecurity' description="Monitoramento e gestão de riscos e vulnerabilidades relacionados à segurança da informação da prefeitura." icon={<RiShieldLine />}>
      <Container id='cybersecurity-container'>
        <CustomIFrame
          id='cybersecurity-iframe'
          src='https://177.21.36.74:8443'
          title='Cybersecurity Information'
          //src='http://fwngp.vtec.net.br:81/v2/guardian/logs/networks'
        ></CustomIFrame>
      </Container>
    </Page>
  );
};

export default PageCybersecurity;
